export const LOCAL_STORAGE_KEYS = {
    TOKEN: "783.LLL",
    ACTIVE_ORG: "2200.3263",
    ACTIVE_DEALER_GROUP: "8401.5267",
};

export const TEMPLATE_EDITOR = {
    EDIT_FIELD: "EDIT_FIELD",
    EDIT_NODE_SIZES: {
        TEXT: { width: 100, height: 38 },
        INITIALS: { width: 100, height: 42 },
        CHECKBOX: { width: 25, height: 25 },
        DATE: { width: 170, height: 30 },
        DROP: { width: 100, height: 35 },
        RADIO: { width: 25, height: 25 },
        SIGNATURE: { width: 200, height: 80 },
    },
};

export const APP_ENV = {
    BUILD_TARGET: process.env.BUILD_TARGET,
    DEFAULT_ORG_ORIGIN: process.env.DEFAULT_ORG_ORIGIN,
    DEALER_GROUP_ORIGIN: process.env.DEALER_GROUP_ORIGIN,
};

export const SUBSCRIPTION_PLAN_CODES = {
    DEALER_GROUP: "dgroup-standard-plan",
    AUSPLAN_DEFAULT: "ausplan-standard-plan",
};
